(function () {
  if (window.__ckPdpShareInit) return;
  window.__ckPdpShareInit = true;

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-ck-share-trigger]');
    var closeBtn = e.target.closest('[data-ck-share-close]');
    var copyBtn = e.target.closest('[data-ck-share-copy]');
    var inside = e.target.closest('[data-ck-share]');

    if (trigger) {
      var wrap = trigger.closest('[data-ck-share]');
      var open = wrap.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      wrap.querySelector('[data-ck-share-tray]').setAttribute('aria-hidden', open ? 'false' : 'true');
      return;
    }

    if (closeBtn) {
      var w1 = closeBtn.closest('[data-ck-share]');
      w1.classList.remove('is-open');
      w1.querySelector('[data-ck-share-trigger]').setAttribute('aria-expanded', 'false');
      w1.querySelector('[data-ck-share-tray]').setAttribute('aria-hidden', 'true');
      return;
    }

    if (copyBtn) {
      e.preventDefault();
      var url = copyBtn.getAttribute('data-share-url');
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          copyBtn.classList.add('is-copied');
          setTimeout(function () { copyBtn.classList.remove('is-copied'); }, 1600);
        });
      }
      return;
    }

    if (!inside) {
      document.querySelectorAll('[data-ck-share].is-open').forEach(function (w) {
        w.classList.remove('is-open');
        w.querySelector('[data-ck-share-trigger]').setAttribute('aria-expanded', 'false');
        w.querySelector('[data-ck-share-tray]').setAttribute('aria-hidden', 'true');
      });
    }
  });
})();
